import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  ModalSeparator,
  ModalSection,
  ModalFooter,
} from '@zen-common/components-base';
import PriceQuantityTotalFormBody from './PriceQuantityTotalFormBody';

/**
 * Renders the price-quantity-total form
 * Should get props from usePriceQuantityTotal hook
 *
 * To be used in a <Modal></Modal> for TAKE
 */
export default function PriceQuantityTotalForm({
  upToQuantity,
  price,
  quantity,
  total,
  limitError,
  onPriceChange,
  onQuantityChange,
  onTotalChange,
  validation,
  submitText = 'Continue',
  cancelText = 'Cancel',
  onSubmit,
  onCancel,
  isPopupModal,
  available,
  isBuy,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit === 'function' && validation.valid) {
      onSubmit();
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <ModalSection>
        <PriceQuantityTotalFormBody
          limitError={limitError}
          onPriceChange={onPriceChange}
          onQuantityChange={onQuantityChange}
          onTotalChange={onTotalChange}
          price={price}
          quantity={quantity}
          total={total}
          validation={validation}
          priceReadOnly
          upToQuantity={upToQuantity}
          available={available}
          isBuy={isBuy}
        />
      </ModalSection>
      <ModalSeparator />
      <ModalFooter>
        <Button type="button" bg="secondary" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button
          type="submit"
          width={isPopupModal ? undefined : '100%'}
          bg="primary"
          disabled={!validation.valid}
        >
          {submitText}
        </Button>
      </ModalFooter>
    </Form>
  );
}
PriceQuantityTotalForm.propTypes = {
  price: PropTypes.object,
  quantity: PropTypes.object,
  total: PropTypes.object,
  limitError: PropTypes.any,
  onPriceChange: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onTotalChange: PropTypes.func,
  validation: PropTypes.object,
  upToQuantity: PropTypes.string,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};
